import { useLocation } from "react-router-dom";
import { SiteHeader, buttonClass } from "@jkast90/kast-common/ui";
import { AccountControls } from "@common/account";

const LINKS = [
  { href: "/#captains", label: "Captains" },
  { href: "/#ships", label: "Ships" },
  { href: "/#art", label: "Art" },
  { href: "/about", label: "About" },
];

// The header: the brand, the page links, "Buy the game" and, at the far end,
// the account bar: Admin (admins with admin tools on) and the profile button,
// which leads to the Account page, where Sign out and Settings live.
export default function Header() {
  const { pathname } = useLocation();
  return (
    <SiteHeader
      className="site-header"
      sticky
      brand={{ alt: "Salvagers", title: "Salvagers" }}
      links={LINKS}
      stackBelow={640}
      activeHref={pathname}
      account={<AccountControls />}
    >
      <a className={buttonClass({ variant: "primary", size: "sm" })} href={SHOP_URL} target="_blank" rel="noreferrer">
        Buy the game
      </a>
    </SiteHeader>
  );
}

export const SHOP_URL = "https://www.thegamecrafter.com/games/permalink/CBD1D5DA-48CC-11F0-8057-C92CFC483417";
